/**
 * Em'z Blendz Product Tabs
 * Handles desktop tab switching and mobile accordion behavior
 */

(function() {
  'use strict';

  function initProductTabs() {
    const containers = document.querySelectorAll('.emz-tabs-container');
    
    containers.forEach(function(container) {
      const tabButtons = container.querySelectorAll('.emz-tab-button');
      const panels = container.querySelectorAll('.emz-tab-panel');
      const accordionTriggers = container.querySelectorAll('.emz-accordion-trigger');

      // Desktop tab click handling
      tabButtons.forEach(function(button) {
        button.addEventListener('click', function() {
          const targetId = this.getAttribute('data-tab');
          
          // Update tab buttons
          tabButtons.forEach(function(btn) {
            btn.classList.remove('active');
          });
          this.classList.add('active');

          // Update panels
          panels.forEach(function(panel) {
            panel.classList.remove('active');
            if (panel.getAttribute('data-tab-panel') === targetId) {
              panel.classList.add('active');
            }
          });
        });
      });

      // Mobile accordion click handling
      accordionTriggers.forEach(function(trigger) {
        trigger.addEventListener('click', function() {
          const isActive = this.classList.contains('active');
          
          // Close all accordions
          accordionTriggers.forEach(function(t) {
            t.classList.remove('active');
          });

          // Toggle current if it wasn't already open
          if (!isActive) {
            this.classList.add('active');
          }
        });
      });

      // Initialize first tab/accordion as active
      if (tabButtons.length > 0) {
        tabButtons[0].classList.add('active');
      }
      if (panels.length > 0) {
        panels[0].classList.add('active');
      }
      if (accordionTriggers.length > 0) {
        accordionTriggers[0].classList.add('active');
      }
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductTabs);
  } else {
    initProductTabs();
  }

  // Also run on Shopify section refresh (for theme editor)
  document.addEventListener('shopify:section:load', initProductTabs);
})();

/**
 * Ingredient Popup Click Handler
 * Intercepts clicks on ingredient links and shows popup instead of navigating
 */
(function() {
  'use strict';
  
  function showIngredientPopup(handle) {
    var dataEl = document.getElementById('ingredient-metaobject-data');
    if (!dataEl) return false;

    var ingredients;
    try { 
      ingredients = JSON.parse(dataEl.textContent); 
    } catch(e) { 
      return false; 
    }

    var ingredient = ingredients[handle];
    if (!ingredient) return false;

    var overlay = document.getElementById('ingredient-popup-overlay');
    var modal = document.getElementById('ingredient-popup-modal');
    if (!overlay || !modal) return false;

    // Handle image
    var imgEl = modal.querySelector('.popup-image');
    if (ingredient.popup_image) {
      if (!imgEl) {
        imgEl = document.createElement('img');
        imgEl.className = 'popup-image';
        var closeBtn = modal.querySelector('.ingredient-popup-close');
        if (closeBtn && closeBtn.nextSibling) {
          modal.insertBefore(imgEl, closeBtn.nextSibling);
        } else {
          modal.insertBefore(imgEl, modal.firstChild);
        }
      }
      imgEl.src = ingredient.popup_image;
      imgEl.style.display = 'block';
    } else if (imgEl) {
      imgEl.style.display = 'none';
    }

    document.getElementById('popup-display-name').textContent = ingredient.display_name || '';
    document.getElementById('popup-brief-description').textContent = ingredient.brief_description || '';
    document.getElementById('popup-best-suited-for').textContent = ingredient.best_suited_for || '';

    var scienceEl = document.getElementById('popup-the-science');
    scienceEl.innerHTML = '';
    if (ingredient.the_science) {
      ingredient.the_science.split(';').forEach(function(point) {
        if (point.trim()) {
          var li = document.createElement('li');
          li.textContent = point.trim();
          scienceEl.appendChild(li);
        }
      });
    }

    document.getElementById('popup-summary').textContent = ingredient.pop_up_summary || '';

    var learnMoreBtn = document.getElementById('popup-learn-more');
    learnMoreBtn.href = '/blogs/ingredients/' + handle;
    learnMoreBtn.target = '_blank';
    learnMoreBtn.textContent = 'Read the Full Story →';

    overlay.style.display = 'block';
    return true;
  }

  // Click handler - capture phase to intercept before navigation
  document.addEventListener('click', function(e) {
    var link = e.target.closest('a[href*="/blogs/ingredients/"]');
    if (!link || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (link.id === 'popup-learn-more') return;
    
    var match = link.getAttribute('href').match(/\/blogs\/ingredients\/([^\/\?#]+)/);
    if (match && showIngredientPopup(match[1])) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  // Close popup handlers
  document.addEventListener('DOMContentLoaded', function() {
    var closeBtn = document.getElementById('ingredient-popup-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        var overlay = document.getElementById('ingredient-popup-overlay');
        if (overlay) overlay.style.display = 'none';
      });
    }

    var overlay = document.getElementById('ingredient-popup-overlay');
    if (overlay) {
      overlay.addEventListener('click', function(e) {
        if (e.target === overlay) overlay.style.display = 'none';
      });
    }
  });

  // ESC key to close
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      var overlay = document.getElementById('ingredient-popup-overlay');
      if (overlay) overlay.style.display = 'none';
    }
  });
})();
